// libraries
import styled from 'styled-components';
import { Form, Input, Checkbox, Button, notification } from 'antd';
import { Typography } from 'antd';
import * as antIcon from '@ant-design/icons';
import { blue, grey } from '@ant-design/colors';
import { useHistory } from 'react-router';

// services
import * as AuthService from '../../../services/bb-api/auth';
import { txt } from '../../../locales/i18n';
import { useEffect } from 'react';

export function LoginRoute(): JSX.Element {
	const history = useHistory();

	useEffect(() => {
		const userId: string | null = localStorage.getItem('bb_user_id') ?? null;
		if (userId === null) return;
		history.replace('/');
	}, [history]);

	async function handleFormSubmit(values: any): Promise<void> {
		let authorizedRoutes: string[] = [];

		try {
			await AuthService.signin(values.email, values.password);

			const authorizedRoutesStore: string = localStorage.getItem('bb_authorized_routes') ?? '[]';
			authorizedRoutes = JSON.parse(authorizedRoutesStore);

			const [entryRoute]: string[] = authorizedRoutes;
			if (entryRoute === undefined) throw new Error('no authorized routes');
			history.push(entryRoute);

			const message: string = txt('login.message', { name: values.email });
			const description: string = txt('login.description');
			notification.success({ message, description });
		} catch (error) {
			notification.error({ message: txt('login.error message') });
		}

		if (values.remember) {
			localStorage.setItem('bb_email', values.email.toLowerCase());
		} else {
			localStorage.removeItem('bb_email');
		}

		if (authorizedRoutes.includes('*')) return history.push('/users');
	}

	function getInitialValues(): any {
		const initialValues: any = { remember: true };
		const email: string | null = localStorage.getItem('bb_email');

		if (email) {
			initialValues.email = email;
		}

		return initialValues;
	}

	const layout = {
		labelCol: { span: 8 },
		wrapperCol: { span: 16 },
	};

	const tailLayout = {
		wrapperCol: { offset: 8, span: 16 },
	};

	return (
		<Container>
			<Typography.Title>
				<span style={{ color: blue.primary }}>BB</span> <span style={{ color: grey[0] }}>Admin</span>
			</Typography.Title>
			<Form {...layout} onFinish={handleFormSubmit} initialValues={getInitialValues()} requiredMark={false}>
				<Form.Item
					label="Email"
					name="email"
					rules={[{ required: true, message: txt('login.email input message') }]}
				>
					<Input />
				</Form.Item>

				<Form.Item
					label="Password"
					name="password"
					rules={[{ required: true, message: txt('login.password input message') }]}
				>
					<Input.Password />
				</Form.Item>

				<Form.Item name="remember" valuePropName="checked" wrapperCol={{ offset: 8, span: 16 }}>
					<Checkbox>{txt('login.remember me')}</Checkbox>
				</Form.Item>

				<Form.Item {...tailLayout}>
					<Button type="primary" htmlType="submit">
						Login <antIcon.LoginOutlined />
					</Button>
				</Form.Item>
			</Form>
		</Container>
	);
}

const Container = styled.main`
	display: flex;
	overflow: scroll;
	align-items: center;
	justify-content: center;
	gap: 2rem;

	position: absolute;
	right: 0;
	width: 100vw;
	height: 100vh;
	overflow-y: auto;

	@media only screen and (max-width: 600px) {
		flex-direction: column;
	}
`;
